import { type ReactElement } from 'react';
import { Div, Grid } from '@fastnorth/kraken/components/layout';
import { CardSkeleton } from '@fastnorth/kraken/components/card';

const FollowingSkeleton = (): ReactElement => (
  <Grid
    data-testid={'following-skeleton'}
    spacing={'0 4'}
    gap={'4'}
    className={'grid-cols-1 sm:grid-cols-2 sm:grid-auto-rows sm:flex-row w-full'}>
    {Array.from({ length: 4 }, (_, idx) => idx).map((id) => (
      <Div
        data-testid={`skeleton-card`}
        key={`following-card-skeleton-${id}`}
        className={'col-span-1'}>
        <CardSkeleton avatar header footer spacing={'2'} />
      </Div>
    ))}
  </Grid>
);

export default FollowingSkeleton;
